import { IMPORT_FILE_EXTENSIONS, MAX_IMPORT_BYTES } from './constants';

export type ValidateImportFileResult = { ok: true } | { ok: false; reason: string };

export const validateImportFile = (file: File): ValidateImportFileResult => {
  const name = file.name.toLowerCase();

  if (!IMPORT_FILE_EXTENSIONS.some((extension) => name.endsWith(extension))) {
    return {
      ok: false,
      reason: `Unsupported file type. Use ${IMPORT_FILE_EXTENSIONS.join(', ')}.`,
    };
  }
  if (file.size === 0) {
    return { ok: false, reason: 'The selected file is empty.' };
  }
  if (file.size > MAX_IMPORT_BYTES) {
    return {
      ok: false,
      reason: `File is too large (max ${Math.round(MAX_IMPORT_BYTES / (1024 * 1024))} MB).`,
    };
  }

  return { ok: true };
};
